'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _profiles = require('./profiles.component');

var _profiles2 = _interopRequireDefault(_profiles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var profilesModule = _angular2.default.module('app.containers.profiles', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('profiles', {
    url: '/profiles',
    template: '<profiles></profiles>'
  });
  // .state('profiles', {
  //   url: '/profiles',
  //   template: '<profiles></profiles>'
  // })
}).component('profiles', _profiles2.default);

exports.default = profilesModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/profiles/profiles.js
 **/